/**
 * Consider background music created before 1 April 2021 as expired (not a joke)
 * 1 - show warning notification until 19 April 2021
 * 2 - remove after that from story and show error notification
 */

import app from 'app';
import { workPool } from '@wochitnpm/helpers';

/** @namespace workPool.job.checkForExpiredBGMusic */
export default workPool.define(
  'checkForExpiredBGMusic',
  {
    initialize() {
      this.date = {
        expireAfter: new Date('2021-04-1 0:00:00 GMT+0000').getTime(),
        removeAfter: new Date('2021-04-19 0:00:00 GMT+0000').getTime(),
      };
    },

    run() {
      const chosenBGMusic = app.rootStore.state.story.storyBackgroundMusic;

      if (chosenBGMusic) {
        const isExpired =
          chosenBGMusic.metadata.creationDate < this.date.expireAfter;
        const isPublic = chosenBGMusic.metadata.privacy === 'PUBLIC';
        const shouldRemove = Date.now() > this.date.removeAfter;

        if (isPublic && isExpired) {
          if (shouldRemove) {
            this.remove();
          } else {
            this.warn();
          }
        }
      }

      this.finish();
    },

    warn() {
      app.notificationController.push({
        text:
          'The music track used on this video is expiring in a few days. ' +
          'We recommend to replace it with music from our great new library!',
        type: 'WARN',
        timeout: app.TIME.second(15),
        uniqueGroupName: 'BGMUSIC_EXPIRATION',
      });
    },

    remove() {
      app.rootStore.dispatch('SET_STORY_BACKGROUND_MUSIC', null);

      app.notificationController.push({
        type: 'ERROR',
        text: 'The music track on this video is no longer available. Choose a new music track!',
        timeout: app.TIME.second(15),
        uniqueGroupName: 'BGMUSIC_EXPIRATION',
      });
    },
  },
  {
    execute() {
      workPool.add(new this());
    },
  }
);
